import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import styles from './EventListPage.module.css';
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';


function EventListPage() {
    const [events, setEvents] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        axios.get(`${API_URL}/api/events`)
            .then(res => setEvents(res.data))
            .catch(console.error);
    }, []);

    return (
        <div className={styles.container}>
            <h2 className={styles.title}>이벤트</h2>
            <div className={styles.grid}>
                {events.map(event => (
                    <div key={event.eventId} className={styles.card}
                        onClick={() => navigate(`/events/${event.eventId}`)}>
                        {event.thumbnailUrl && (
                            <img src={`${API_URL}${event.thumbnailUrl}`}
                                alt={event.title} className={styles.thumbnail} />
                        )}
                        <div className={styles.info}>
                            <p className={styles.eventTitle}>{event.title}</p>
                            {event.startDate && event.endDate && (
                                <p className={styles.period}>
                                    {new Date(event.startDate).toLocaleDateString()} ~{' '}
                                    {new Date(event.endDate).toLocaleDateString()}
                                </p>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default EventListPage;